import { createAsyncThunk } from '@reduxjs/toolkit';
import { credentialService } from '../../services/api';

export const fetchCredentials = createAsyncThunk(
  'credentials/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await credentialService.getAll();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchCredentialById = createAsyncThunk(
  'credentials/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await credentialService.getById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createCredential = createAsyncThunk(
  'credentials/create',
  async (credential, { rejectWithValue, dispatch }) => {
    try {
      const response = await credentialService.create(credential);
      dispatch(fetchCredentials());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCredential = createAsyncThunk(
  'credentials/update',
  async ({ id, credential }, { rejectWithValue, dispatch }) => {
    try {
      const response = await credentialService.update(id, credential);
      dispatch(fetchCredentials());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCredential = createAsyncThunk(
  'credentials/delete',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await credentialService.delete(id);
      dispatch(fetchCredentials());
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
